import { useScrollGetPropertyPhoneCategories } from "service/property/phone-category";
import { CSelectPagination } from "./pagination";

export const CSelectPropertyPhoneCategory = ({ ...props }) => {
  return (
    <CSelectPagination
      {...props}
      useQuery={useScrollGetPropertyPhoneCategories}
      valueKey='id'
      labelKey='name'
      searchKey='name'
      translation
      queryParams={{
        isActive: true,
      }}
    />
  );
};
